import { render, staticRenderFns } from "./Vue2-sub.vue?vue&type=template&id=7bdbdd02&scoped=true&"
import script from "./Vue2-sub.vue?vue&type=script&lang=js&"
export * from "./Vue2-sub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdbdd02",
  null
  
)

export default component.exports